import { render, staticRenderFns } from "./B-5-1__Career_MainMessaging.vue?vue&type=template&id=38e63a0a&"
import script from "./B-5-1__Career_MainMessaging.vue?vue&type=script&lang=js&"
export * from "./B-5-1__Career_MainMessaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports